import { BASEDOMAIN, USER_PORTAL_ADDRESS } from "@/constants/allconstants";

export const LABELS = {
    EMAIL: "Email",
    PASSWORD: "Password",
    ROLES: "Roles",
    RESET_PASSWORD: "Reset Password",
    RETURN_TO_LOGIN: "Return to Login",
    EMAIL_ADDRESS: "Email Address",
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    LOCK_RECIPIENT_NAME: "Lock Recipient Name",
    HIDE_SIGNATURE_FRAME: "Hide Signature Frame",
    SHARED_ACCESS_ENABLE: "Shared Access",
    DECLINE_TO_SIGN: "Decline To Sign",
    CORRECT_ENVELOPE_BY_RECIPIENTS: "Correct Envelope by Recipients",
    DOMAIN_RESTRICTION_FOR_RECIPIENTS: "Domain Restrictions for Recipients",
    DOMAIN_RESTRICTION_FOR_SIGNUP: 'Domain Restriction for Signup/Login',
    DIRECTORY_SERVICE_ENABLE: "Directory Services",
    MANAGE: "Manage",
    SHAREPOINT_HOST_INPUT_LABEL: "Enter host e.g contoso.sharepoint.com",
    ROLE_NAME: "Role Name",
    GROUP_NAME: "Group Name",
    VIEW_DETAILS: "View Details",
    BRAND_NAME: "Brand Name",
    COMPANY_NAME: "Company Name",
    STATUS: "Status",
    BRAND_ID: "Brand ID",
    LINE_SEPERATED_EMAILS: "Enter line separated email address",
    CURRENT_PASSWORD: "Current Password",
    NEW_PASSWORD: "New Password",
    SIGNING_LOGO: "Signing Logo",
    UPLOAD_SIGNING_LOGO: "Upload Signing Logo",
    EMAIL_LOGO: "Email Logo",
    UPLOAD_EMAIL_LOGO: "Upload Email Logo",
    PASSWORD_ENABLED: "Login via SSO only",
    UNIQUE_FIELD_VALIDATION: "Unique Field Validation",
    ALLOW_SHARING: "Allow Sharing",
    DOCUMENT_SEARCH_ENABLED: "Allow Document Search",
    RECIPIENT_REASSIGNMENT_ENABLED: "Recipient Reassignment",
    CONNECTED: 'Connected',
    DISCONNECTED: 'Disconnected',
    TENANT_ID: 'tenant Id',
    OLD_EMAIL: 'Old Email',
    NEW_EMAIL: 'New Email',
    VERIFICATION_CODE: 'Verification Code',
    RESEND_CODE: 'Resend Code',
    SUPPLEMENTAL_DOCUMENT_ALLOWED: 'Allow Supplemental Documents',
    SUBJECT: 'Subject',
    MESSAGE: 'Message',
    TAG_NAME: 'Tag Name',
    TRANSFER_OWNERSHIP: 'Transfer Ownership',
    TRANSFERRING: 'Transferring...',
    SELECT_USER: 'Select User',
    LOADING_USERS: 'Loading users...',
    SEARCH_FOR_USER: 'Search for a user...',
    TYPE_TO_SEARCH: 'Type at least 2 characters to search',
    NO_USERS_FOUND: 'No users found',
    SELECTED: 'selected',
    TRANSFER_TEMPLATE_OWNERSHIP: 'Transfer Template Ownership',
    TRANSFER_FORM_OWNERSHIP: 'Transfer Form Ownership',
    TRANSFER_WEB_FORM_OWNERSHIP: 'Transfer Web Form Ownership',
    TRANSFER_ENVELOPE_OWNERSHIP: 'Transfer Envelope Ownership',
    TRANSFER_OWNERSHIP_DESCRIPTION: 'Select a user to transfer ownership of this template. The selected user will become the new owner and will have full control over this template.',
    TRANSFER_FORM_OWNERSHIP_DESCRIPTION: 'Select a user to transfer ownership of this form. The selected user will become the new owner and will have full control over this form. Associated envelopes will also be transferred; form and envelope data, history, and configuration are preserved.',
    TRANSFER_WEB_FORM_OWNERSHIP_DESCRIPTION: 'Select a user to transfer ownership of this web form. The selected user will become the new owner and will have full control over this web form. Associated envelopes will also be transferred; form and envelope data, history, and configuration are preserved.',
    TRANSFER_ENVELOPE_OWNERSHIP_DESCRIPTION: 'Select a user to transfer ownership of this envelope. The selected user will become the new owner and will have full control over this envelope.',
    BULK_TRANSFER_TEMPLATE_OWNERSHIP_DESCRIPTION: 'Select a user to transfer ownership of the selected templates. The selected user will become the new owner and will have full control over these templates.',
    BULK_TRANSFER_FORM_OWNERSHIP_DESCRIPTION: 'Select a user to transfer ownership of the selected forms. The selected user will become the new owner and will have full control over these forms. Associated envelopes will also be transferred; form and envelope data, history, and configuration are preserved.',
    BULK_TRANSFER_WEB_FORM_OWNERSHIP_DESCRIPTION: 'Select a user to transfer ownership of the selected web forms. The selected user will become the new owner and will have full control over these web forms. Associated envelopes will also be transferred; form and envelope data, history, and configuration are preserved.',
    BULK_TRANSFER_ENVELOPE_OWNERSHIP_DESCRIPTION: 'Select a user to transfer ownership of the selected envelopes. The selected user will become the new owner and will have full control over these envelopes.',
};
export const PLACEHOLDERS = {
    EMAIL: "Enter your email address",
    PASSWORD: "Enter your password",
    OTP_PLACEHOLDER: "Enter OTP of 4 digits",
    SHAREPOINT_HOST: "Sharepoint host",
    REASON_FOR_REJECTION: "Enter reason for rejection",
    EMAIL_SUBJECT: "Enter email subject",
    EMAIL_BODY: "Enter your message",
    SEARCH: "Quick search",
    DOCUMENT_SEARCH: "Quick search including documents",
};
export const HEADINGS = {
    LOGIN: "Admin Login",
    RESET_PASSWORD: "Reset Password",
    SET_PASSWORD: "Set Password",
    TWO_FACTOR_AUTHENTICATION: "Two Factor Authentication",
    CHANGE_PASSWORD: "Reset Password",
    MY_ORGANIZATIONS: "My Organizations",
    ADD_ROLES: "Add Roles",
    ADD_GROUPS: "Add Groups",
    ADD_USERS: "Add Users",
    MY_PROFILE: "My Profile",
    LICENSE_DETAILS: "License Details",
    AI_CONFIGURATIONS: "AI Configurations",
    DEVELOPER_OPTIONS: "Developer Options",
    WEBHOOK: "Webhook",
    INTEGRATION: "Integration",
    LOGOUT_REDIRECT: "Logout Redirect",
    REGIONAL: "Regional",
    SHAREPOINT: "SharePoint",
    OPEN_AI: "Open AI",
    AZURE_OPEN_AI: "Azure Open AI",
    CLAUDE_AI: "Claude AI",
    GEMINI_AI: "Gemini AI",
    TIMEZONE: "Time Zone for the account",
    MANAGE_YOUR_SHAREPOINT_HOST: "Manage Your Sharepoint Host",
    PERMISSIONS: "Permissions",
    CREATE_ROLE: "Create Role",
    CREATE_GROUP: "Create Group",
    ROLES: "Roles",
    GROUPS: "Groups",
    USERS: "Users",
    BRAND_INFO: "Brand Information",
    INFO: "info",
    CUSTOMIZE_WHAT_RECIPIENT_SEE: "Customize what recipient see",
    BRANDING: "Branding",
    CUSTOMIZE_SIGNING_EMAIL: "Customize Signing & Email",
    SIGNING: "Signing",
    EMAIL: "Email",
    INVITE_USERS: "Invite Users",
    BULK_USERS: "Bulk Users",
    SINGLE_USER: "Single User",
    LOGOS: "Logos",
    BRANDS: "Brands",
    DIRECTORY_SERVICES: "Directory Services",
    URLS: "URLs",
    ENVELOPES: "Envelopes",
    AZURE_INSTRUCTION_HEADER: "Microsoft Entra tenant ID",
    UPDATE_EMAIL: "Update Email",
    VERIFY_EMAIL: "Verify Email",
    TOKENS_USED: "Tokens Used",
    MONTHLY_QUOTA: "Monthly Quota",
    MODEL: "Model (ie: gpt-4o, gpt-4o-mini, etc) see ",
    ENDPOINT: "Azure Endpoint",
    DEPLOYMENT: "Azure Deployment Name",
    API_VERSION: "API Version",
    MARK_AS_DEFAULT: "Mark as Default",
    MARK_AS_ACTIVE: "Mark as Active",
    IS_ACTIVE: "Is Active",
    API_KEY: "API Key",
    MONTHLY_USAGE_LIMIT: "Monthly Token Usage Limit, leave blank for no limit. (ie: resets next month)",
    CONFIGURATION_REVOKED_SUCCESSFULLY: "Configuration revoked successfully",
    CONFIGURATION_UPDATED_SUCCESSFULLY: "Configuration updated successfully",
    REVOKE_CONFIRMATION_MESSAGE: "Are you sure you want to revoke this configuration?",
    REVOKE_CONFIRMATION_TITLE: "Revoke Configuration",
    CONFIGURATION: "Configuration",
    DOCUMENTATION: "documentation",
    FOR_MORE_INFORMATION: "for more information.",
    REQUIRED_FIELDS: "Please fill in all required fields.",
    MODELS: "Model(s)",
    UPLOAD_CREDENTIALS: "Upload Credentials",
    MANAGE: "Manage",
    CREDENTIALS: "Credential(s)",
    ALLOW_MESSAGES_LIMIT: "Allow Messages Limit",
    MESSAGES_LIMIT: "Daily messages limit per user",
    CONTACT_USER: "Contact User",
    EDIT_TAG: "Edit Tag",
    DELETE_TAG: "Delete Tag",
    ADD_TAG: "Add Tag",
};
export const NO_SEARCH_RESULTS = "No results found for this search";

export const TOAST_MESSAGES = {
    AI_CONFIGURATION_SAVED_SUCCESSFULLY: "AI Configuration saved successfully",
}
export const BUTTONS = {
    LOGIN: "Login",
    REGISTER: "Register",
    SIGN_IN: "Sign In",
    SEND_RESET_LINK: "Send Reset Link",
    SEND_SET_PASSWORD_LINK: "Send Set Password Link",
    VALIDATE: "Validate",
    RESET_PASSWORD: "Reset Password",
    RESEND_OTP: "Resend OTP",
    INVITE_USERS: "Invite Users",
    DONE: "Done",
    CANCEL: "Cancel",
    CLEAR_SELECTION: "Clear",
    SAVE: "Save",
    UPDATE: "Update",
    CREATE: "Create",
    EDIT: "Edit",
    FILTER: "Filters",
    APPLY: "Apply",
    RESET: "Reset",
    BRAND: "Brand",
    ADD_BRAND: "Add Brand",
    CREATE_YOUR_THEME: "Create Your Theme",
    DELETE: "Delete",
    CONFIRM: "Confirm",
    ADD_ROLES: "Add Roles",
    ADD_GROUPS: "Add Groups",
    INVITE: "Invite",
    INVITE_ALL_USERS: "Invite All Users",
    IMPORT_FROM_AD: "Import from Directory Service",
    BACK_TO_DASHBOARD: "Back to Dashboard",
    BACK_TO_LOGIN: "Back to Login",
    CHANGE_PASSWORD: "Change Password",
    APPLY_BRAND: "Apply Brand",
    LOAD_ALL: "Load All",
    RESEND: "Resend",
    NEXT: "Next",
    SUBMIT: "Submit",
    CONNECT_YOUR_ENTRA_ID: "Connect your Entra ID",
    GRANT_ACCESS: "Grant Access",
    ADD: 'Add',
    CLOSE: 'Close',
    UPLOAD: 'Upload',
    VERIFY: 'Verify',
    SEND_CODE: 'Send Code',
    CONTINUE: 'Continue',
    ACTIVATE: 'Activate',
    DEACTIVATE: 'Deactivate',
    REVOKE: 'Revoke',
    HIDE_API_KEY: 'Hide API key',
    SHOW_API_KEY: 'Show API key',
    SUSPEND: 'Suspend User',
    UNSUSPEND: 'Unsuspend User',
    APPROVED: "Approved",
    REJECTED: "Rejected",
    APPROVED_WITH_FLAG: "Approved with Flag",
    SEND_FOR_REVIEW: "Send for Review",
    CONTACT_SUPPORT: "Contact Support",
    CANCEL_SENDING: "Cancel Sending",
    SEND: "Send",
};
export const SIDEBAR_TEXTS = {
    Dashboard: "Dashboard",
    Users: "Users",
    Contacts: "Contacts",
    Admins: "Admins",
    ReportedUsers: "Reported Users",
    Roles: "Roles",
    Groups: "Groups",
    Envelopes: "Envelopes",
    Templates: "Templates",
    Forms: "Forms",
    WebForms: "Web Forms",
    Settings: "Settings",
    Brand: "Brands",
    Logs: "Logs",
    Tags: "Tags",
    ManageAI: "Manage AI",
};

export const FORM_SIGN_LINK = (link_id: any) => `${USER_PORTAL_ADDRESS}/sign-form/${link_id}`
export const USER_PROFILE_DROPDOWN = {
    SWITCH_PROFILE: "Switch Profile",
    VIEW_PROFILE: "View Profile",
    CHANGE_PASSWORD: "Change Password",
    USER_PORTAL: "User Portal",
    SIGN_OUT: "Sign out",
};
export const STATS = {
    ADMINS: "Admins",
    USERS: "Users",
    ENVELOPES: "Envelopes",
    DOCUMENTS: "Documents",
};

export const TEXT = {
    DEVELOPER_OPTION_TEXT: "Information related to GreenSign for developers.",
    SIGNATURE_ADOPTION_CONFIGURATION: "Signature adoption configuration.",
    REGISTER_FOR_SHAREPOINT_WITH_GREENSIGN: "Register your Sharepoint host with GreenSign",
    INSTRUCTIONS_FOR_ADDING_SHAREPOINT_ADDIN: "Instructions for Adding SharePoint Addin",
    SAML_INSTRUCTION_HEADING: "Create a new application for SSO in Microsoft Entra ID",
    OIDC_INSTRUCTION_HEADING: "Connect OIDC for SSO in Microsoft Entra ID",
    ALL_BRAND_LIST_HERE: "All brands of this organization are listed here",
    ADD_LOGO_AND_BRAND: "Add your logo and brand colors to emails and the signing experience.",
    DO_YOU_WANT_TO_DEACTIVATE_USER: "Are you sure you want to deactivate this user?",
    DO_YOU_WANT_TO_ACTIVATE_USER: "Are you sure you want to activate this user?",
    RESET_SUCCESS_TITLE: "Get Password Recovery Link From Your Email",
    SET_SUCCESS_TITLE: "Get Set Password Link From Your Email",
    RESET_SUCCESS_MESSAGE: "We want to make sure it's really you. In order to further verify your identity, access the password recovery link sent to your email.",
    SET_SUCCESS_MESSAGE: "We want to make sure it's really you. In order to further verify your identity, access the set password link sent to your email.",
    EMAIL_MISMATCH_TITLE: "Access Denied: Email Mismatch",
    EMAIL_MISMATCH_MESSAGE: "The email address you entered does not match the email associated with your Microsoft Entra ID account. Please try again.",
    SELECT_REASON: "Select Reason for Suspension",
    SUSPEND_USER_TITLE: "Suspend User",
    ENTER_REASON_FOR_SUSPENSION: "Enter the reason for suspension",
};

export const AZURE_REGISTRATION_STEPS = ["1. Go to your SharePoint Admin page", "2. From the left hand menu, go to 'More Features'", "3. Click Open in Apps section", "4. Click on 'Upload' and upload the file provided to you by GreenSign officials", "5. Go to the homepage of the site you want to add the addin in", "6. Go to 'Site Contents'", "7. Click 'New' and select 'App'", "8. You should see GreenSign app there. Click 'Add'", "9. A popup will appear. Click 'Trust it'"];
export const  SAML_INSTRUCTION = {
    step1: `1. Go to the <a href="https://entra.microsoft.com" target="_blank" rel="noopener noreferrer">Microsoft Entra ID portal</a> and browse to Microsoft Entra ID and follow Identity > Applications > Enterprise applications.`,
    step2: "2. Click + New application.",
    step3: "3. Type in a relevant name, select Non-gallery application, and click Create.",
    step4: "4. After this you're redirected to the newly created application Overview, go to Getting started via the left side menu and click Configure single sign-on (or click Single sign-on from the side menu).",
    step5: "5. Select SAML as the single sign-on method.",
    step6: "6. Click on the pencil icon to Edit step 1, the Basic SAML Configuration.",
    step7: "7. Add the following values and save:",
    step7a: "Identifier (Entity ID):",
    step7b: (url: string) => `${url}`,
    step8: "8. Under step 3, download the Federation Metadata XML and upload it here.",
}
export const  OIDC_INSTRUCTION = {
    step1: `1. Log in to the <a href="https://entra.microsoft.com" target="_blank" rel="noopener noreferrer">Microsoft Entra ID portal</a> and navigate to Microsoft Entra ID > Properties.`,
    step2: "2. Locate the Tenant ID under Tenant ID section and copy it.",
    step3: "3. Paste the Tenant ID from the portal into the required field.",
    step4: "4. Submit the Tenant ID to proceed to the Microsoft consent screen.",
    step5: "5. Review the requested permissions, including access to directory data and user profiles.",
    step6: "6. Provide consent to grant the requested permissions.",
    step7: "7. Once consent is granted, you will be redirected back to the application.",
}

export const TABLE_HEADERS = {
    USER: "User",
    EMAIL: "Email",
    ROLE: "Role",
    STATUS: "Status",
    GROUP: "Group",
    CREATED_AT: "Created At",
    UPDATED_AT: "Updated At",
    LAST_LOGIN_AT: "Last Login At",
    LAST_CHANGED: "Last Changed",
    OWNER: "Owner",
    RESPONSES: "Responses",
    SENDER: "Sender",
    NAME: "Name",
    ENVELOPE_COUNT: "Envelope Count",
    DELETED_ENVELOPE_COUNT: "Deleted Envelope Count",
    TOTAL_ENVELOPE_COUNT: "Total Envelope Count",
    PERMISSION: "Permission",
    SUBJECT: "Subject",
    SENT_BY: "Sent By",
    ACTION: 'Action',
    MESSAGE: 'Message',
    ACTION_BY: 'Action By',
    ACTION_ON: 'Action On',
    CATEGORY: 'Category',
    IP: 'IP Address',
    LATITUDE: 'Latitude',
    LONGITUDE: 'Longitude',
    REPORT_REASON: "Report Reason",
    REPORTED_AT: "Reported At",
    CREATED_BY: "Created By",
    USAGE_COUNT: "Usage Count",
    ACTIONS: "Actions",
};

export const STATUS = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
];

export const GLOBAL_ORGANIZATION = 'GLOBAL'

export const SWITCH_ORGANIZATION_MODAL = {
    ROW_HEIGHT_REM: 3.125,
    MAX_VISIBLE_ORGANIZATIONS: 4,
} as const;

export const THEME_MODAL_TEXTS = {
    DO_NOT_SHARE_EMAIL_MESSAGE: "Keep This Email Private",
    ABOUT_GREENSIGN_MESSAGE: "About GreenSign",
    QUESTION_ABOUT_DOC_MESSAGE: "Questions about the Document?",
    INFO_MESSAGE: "This message was sent to you by %%SENDERSNAME%% who is using the GreenSign Electronic Signature Service. If you would rather not receive email from this sender you may contact the sender with your request.",
    SECURE_LINK_MESSAGE: "For your security, please keep this email and its content confidential.",
    SIGN_DOCUMENT_MESSAGE: "Sign documents electronically in just minutes. It's safe, secure, and legally binding. Whether you're in an office, at home, on-the-go -- or even across the globe.",
    MODIFY_DOCUMENT_MESSAGE: "If you need to modify the document or have questions about the details in the document, please reach out to the sender by emailing them directly.",
    TROUBLE_SIGNING_DOCUMENT_MESSAGE: "If you are having trouble signing the document, please contact",
    INFO_MESSAGE_2: "This message was sent to you by %%SENDERSNAME%% who is using the GreenSign Electronic Signature Service. If you would rather not receive email from this sender you may contact the sender with your request.",
}

export const USER_STATUS = {
    ACTIVE: 'active',
    SUSPENDED: 'suspended',
    INACTIVE: 'inactive',
}

export const SUCCESS_MESSAGES = {
    USER_SUSPENDED: "User suspended successfully",
    USER_UNSUSPENDED: "User unsuspended successfully",
    USER_MARKED_SAFE: "User marked as safe successfully",
}

export const PREDEFINED_REASONS = [
    "Violation of Terms of Service",
    "Security Concerns",
    "Account Inactivity",
    "Suspicious Activity"
];

export const REVIEW_REPORTED_ENVELOPE = {
    HEADER_TEXT: "Review Reported Envelope",
    SUB_HEADING_TEXT: "This envelope has been reported as spam. Please review the envelope and take appropriate action.",
    REVIEW_DETAILS_TEXT: "Please review the Details.",
    ENVELOPE_CREATED_BY_TEXT: "Envelope created by:",
    ENVELOPE_CREATED_AT_TEXT: "Envelope created at:",
    ENVELOPE_STATUS_TEXT: "Envelope status:",
}

export const REJECT_ENVELOPE_MODAL = {
    REASON_FOR_REJECTION_TEXT: "Reason for Rejection",
    REJECT_ENVELOPE_BUTTON_TEXT: "Reject Envelope",
    PLACEHOLDER_TEXT: "Please provide a reason for rejecting this envelope",
}

export const REVIEW_STATUS = {
    REJECTED: "Rejected",
    FLAGGED: "Flagged",
    APPROVED: "Approved",
    PENDING: "pending",
}

export const REPORTED_USER_TABLE = {
    USER: "User",
    NO_OF_REPORT_ENVELOPES: "No. of Reported Envelopes",
    STATUS: "Status",
    ACTIONS: "Actions",
    SUSPEND_USER: "Suspend User",
    CONTACT_USER: "Contact User",
    MARK_AS_SAFE: "Mark as Safe",
    NO_RESULTS: "No results found for this search",
    LOAD_ALL: "Load All",
    SELECT_REASON: "Select Reason for Suspension",
    SUSPEND_USER_TITLE: "Suspend User",
    ENTER_REASON_FOR_SUSPENSION: "Enter the reason for suspension",
    MESSAGE_SENT_SUCCESS: "Message sent successfully",
    TRANSFER_OWNERSHIP: "Transfer Ownership",
    SELECT_USER: "Select User",
    SEARCH_FOR_USER: "Search for a user...",
    LOADING_USERS: "Loading users...",
    TYPE_TO_SEARCH: "Type at least 2 characters to search",
    NO_USERS_FOUND: "No users found",
    TRANSFERRING: "Transferring...",
    TRANSFER_TEMPLATE_OWNERSHIP: "Transfer Template Ownership",
    TRANSFER_OWNERSHIP_DESCRIPTION: "Select a user to transfer ownership of this template. The selected user will become the new owner and will have full control over this template."
}

export const NO_RECORD_FOUND_TEXT_WITH_TITLE_AND_DESCRIPTION: Record<string, { TITLE: string; DESCRIPTION: string }> = { 
    INBOX: {
        TITLE: "Everything Sent to You in One Place",
        DESCRIPTION: "You'll find envelopes sent to you here."
    },
    ACTION_REQUIRED: {
        TITLE: "Anything Waiting on You Will Be Here",
        DESCRIPTION: "Whether you need to view or sign, it'll be here."
    },
    COMPLETED: {
        TITLE: "If It's Done, It's Here",
        DESCRIPTION: "Envelopes that have been signed by everyone live here."
    },
    DRAFTS: {
        TITLE: "Need Time Before Sending?",
        DESCRIPTION: "It can take time to get your work right. Until you're ready, it'll live here."
    },
    EXPIRED: {
        TITLE: "If It's Expired, It's Here",
        DESCRIPTION: "Envelopes not completed within their deadline."
    },
    EXPIRING_SOON: {
        TITLE: "If It's Urgent, It's Here",
        DESCRIPTION: "Envelopes expiring within 6 days live here."
    },
    SENT: {
        TITLE: "Everything You Send in one Place",
        DESCRIPTION: "We'll track and store your sent envelopes here."
    },
    WAITING_FOR_OTHERS: {
        TITLE: "Easily Track Your Envelopes",
        DESCRIPTION: "Find out who you're waiting on here."
    },
    FORM_ENVELOPES: {
        TITLE: "All Your Form Envelopes in one Place",
        DESCRIPTION: "We'll track and store your form envelopes here."
    },
    TEMPLATE_ENVELOPES: {
        TITLE: "All Your Template Envelopes in one Place",
        DESCRIPTION: "We'll track and store your template envelopes here."
    },
    RECIPIENTS: {
        TITLE: "All Your Recipients in One Place",
        DESCRIPTION: "You'll find the created recipients here."
    },
    DOCUMENTS: {
        TITLE: "All Your Documents in One Place",
        DESCRIPTION: "You'll find the created documents here."
    },
    TEMPLATES: {
        TITLE: "All Your Templates in One Placess",
        DESCRIPTION: "You'll find the created templates here."
    },
    FORMS: {
        TITLE: "All Your Forms in One Place",
        DESCRIPTION: "You'll find the organization's forms here."
    },
    WEB_FORMS: {
        TITLE: "All Your Web Forms in One Place",
        DESCRIPTION: "You'll find the organization's web forms here."
    },
    ENVELOPES: {
        TITLE: "All Your Envelopes in One Place",
        DESCRIPTION: "You'll find the created envelopes here."
    },
    SHARED_ACCESS: {
        TITLE: "All Your Shared Access in One Place",
        DESCRIPTION: "You'll find the created shared access here."
    },
    CONFIGURATION: {
        TITLE: "All Your Configuration in One Place",
        DESCRIPTION: "You'll find the created configuration here."
    },
    FEATURES: {
        TITLE: "All Your Features in One Place",
        DESCRIPTION: "You'll find the created features here."
    },
    ROLES: {
        TITLE: "All Your Roles in One Place",
        DESCRIPTION: "You'll find the created roles here."
    },
    LOGOUT: {
        TITLE: "All Your Logout in One Place",
        DESCRIPTION: "You'll find the created logout here."
    },
    DOCUMENT_HISTORY: {
        TITLE: "Version History",
        DESCRIPTION: "You'll find the version history of the document here."
    },
    TAGS: {
        TITLE: "If It's Tagged, It's Here",
        DESCRIPTION: "Envelopes that have been tagged live here."
    }
}